import classNames from 'classnames';
import React from 'react';

import Typography, { TextColors, TextSizes } from '@Components/Typography';
import { buildMessageKeyForEnum } from '@Config/messages';
import { AdvertServiceType, AdvertType } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';

import styles from './AdServiceTypeDisplay.module.scss';

export enum DotColor {
  white = 'white',
  primary = 'primary',
}

interface AdServiceTypeDisplayProps {
  size: TextSizes;
  color: TextColors;
  service: AdvertServiceType;
  type: AdvertType;
  bold?: boolean;
  dotColor: DotColor;
}

const AdServiceTypeDisplay: React.FC<AdServiceTypeDisplayProps> = ({ service, type, color, size, bold, dotColor }) => {
  const t = useTranslations();

  return (
    <div className={styles.container}>
      <Typography
        color={color}
        className={styles.label}
        msg={t(buildMessageKeyForEnum(type))}
        tag="span"
        size={size}
        align="center"
        bold={bold}
      />
      <div className={classNames(styles[dotColor])} />
      <Typography
        color={color}
        className={styles.label}
        msg={t(buildMessageKeyForEnum(service))}
        tag="span"
        size={size}
        align="center"
        bold={bold}
      />
    </div>
  );
};

export default AdServiceTypeDisplay;
